import { TOUR_BASE_QUERY_KEY } from '@/features/dashboard/tours/api/toursApi.queryKeys.ts';

export const DASHBOARD_KEY_SEGMENT = 'dashboard';
export const DASHBOARD_FINANCE_KEY_SEGMENT = 'finance';
export const DASHBOARD_SUMMARY_KEY_SEGMENT = 'summary';
export const DASHBOARD_OPTIONS_KEY_SEGMENT = 'options';
export const DASHBOARD_SALES_KEY_SEGMENT = 'sales';

/** Klucze, które zmienia ruch w rezerwacjach — finanse mają własny strażnik. */
export const DASHBOARD_STATS_KEY_SEGMENTS = [
  DASHBOARD_SUMMARY_KEY_SEGMENT,
  DASHBOARD_OPTIONS_KEY_SEGMENT,
  DASHBOARD_SALES_KEY_SEGMENT,
] as const;

/** Klucze kart ekranu wyjazdu — pod tym samym korzeniem co reszta wyjazdu. */
export const tourDashboardApiQueryKeys = {
  summary: (tourId: string) =>
    [
      TOUR_BASE_QUERY_KEY,
      tourId,
      DASHBOARD_KEY_SEGMENT,
      DASHBOARD_SUMMARY_KEY_SEGMENT,
    ] as const,
  finance: (tourId: string) =>
    [
      TOUR_BASE_QUERY_KEY,
      tourId,
      DASHBOARD_KEY_SEGMENT,
      DASHBOARD_FINANCE_KEY_SEGMENT,
    ] as const,
  options: (tourId: string) =>
    [
      TOUR_BASE_QUERY_KEY,
      tourId,
      DASHBOARD_KEY_SEGMENT,
      DASHBOARD_OPTIONS_KEY_SEGMENT,
    ] as const,
  sales: (tourId: string) =>
    [
      TOUR_BASE_QUERY_KEY,
      tourId,
      DASHBOARD_KEY_SEGMENT,
      DASHBOARD_SALES_KEY_SEGMENT,
    ] as const,
};
